/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../../../../../core/components';
import { Component, ElementRef, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-add-form-row',
    templateUrl: './add-form-row.component.html',
    styleUrls: ['./add-form-row.component.scss']
})

export class AddFormRowComponent extends BaseComponent {
    /**
     * Reference to DOM ng-content
     */
    @ViewChildren('rowInputs')
    public rowInputs: QueryList<any> = new QueryList<any>();

    /**
     * Reference to DOM ng-content
     */
    @ViewChild('addButton', { static: true })
    public addButton: ElementRef;

    /**
     * Form control name used to associate this control with the parent control.
     */
    @Input() public formControlName: string;

    /**
     * Our form group
     */
    @Input() set formGroup(value: FormGroup) {
        this._formGroup = value;
    }

    /**
     * Form control validators.
     */
    @Input() public formTitle: string = 'certificate_input_subject_alt';

    /**
     * Form control validators.
     */
    @Input() public formRowValidation: any[] = [];

    /**
     * Store the help tag.
     */
    @Input() helpTag: string;

    /**
     * Our from group literal
     * @private
     */
    private _formGroup: FormGroup;

    /**
     * Store rows
     * @private
     */
    private _rows: FormArray;

    constructor() {
        super();
    }

    /**
     * Getter for rows.
     */
    get rows(): FormArray {
        this._rows = this.formGroup.get(this.formControlName) as FormArray;

        return this._rows;
    }

    /**
     * Get the parent form group.
     */
    get formGroup() {
        return this._formGroup;
    }

    /**
     * Returns form control as FormControl.
     * @param control
     */
    public getFormControl(control: any): FormControl {
        return control as FormControl;
    }

    /**
     * Add form row.
     */
    public addRow(): void {
        this.rows.push(new FormControl('', this.formRowValidation));
        this.focusNewRowInput();
    }

    /**
     * Delete form row .
     * @param index
     */
    public deleteRow(index: number): void {
        this.rows.removeAt(index);
        this.focusNewRowInput();
    }

    /**
     * Enable and disables the add button for row.
     * @param index
     */
    public rowIsInvalid(index: number): boolean {
        if (!this.rows.controls[index].value.length) {
            return true;
        }

        return this.rows.controls[index].invalid;
    }

    /**
     * Focus cursor to the last/new row on the form.
     * @private
     */
    private focusNewRowInput(): void {
        const timerId = setTimeout((): void => {
            this.rowInputs.last.nativeElement.focus();
            clearTimeout(timerId);
        }, 50);
    }
}
